<ife-progress-bar
  *ngIf="(step$ | async) !== quoteSteps.intro"
  [step$]="step$"
  [stepOrder]="quoteStepsOrder"
  [barType]="ProgressBarType.line"
  [isCompleted$]="isCompleted$"
>
</ife-progress-bar>

<div class="pt-24 mx-auto w-max container" data-cy="evc-quote">
  <ife-progress-bar
    *ngIf="(step$ | async) !== quoteSteps.intro && activeStep !== quoteSteps.confirmation"
    [step$]="step$"
    [stepOrder]="quoteStepsOrder"
    [barType]="ProgressBarType.text"
  >
  </ife-progress-bar>
</div>

<evc-quote-intro *ngIf="activeStep === quoteSteps.intro" (stepReady)="startQuote()"></evc-quote-intro>

<form [formGroup]="control">
  <evc-quote-car-details
    *ngIf="(step$ | async) === quoteSteps.carDetails"
    formControlName="carDetails"
    (stepNavigation)="stepNavigation($event)"
    (formReady)="saveAndGoToStep(quoteSteps.chargingStationDetails)"
  ></evc-quote-car-details>

  <evc-quote-charging-station-details
    *ngIf="(step$ | async) === quoteSteps.chargingStationDetails"
    [activeStep]="activeSubStep"
    formControlName="chargingStationDetails"
    (stepNavigation)="stepNavigation($event)"
    (formReady)="saveAndGoToStep(getChargingStationDetailsNextStep())"
    (goBack)="saveAndGoToStep(quoteSteps.carDetails, true)"
  ></evc-quote-charging-station-details>

  <evc-quote-technical-details
    *ngIf="(step$ | async) === quoteSteps.technicalDetails"
    [id]="quote.id"
    [email]="quote.email"
    [activeStep]="activeSubStep"
    formControlName="technicalDetails"
    (stepNavigation)="stepNavigation($event)"
    (formReady)="saveAndGoToStep(quoteSteps.houseDetails)"
    (goBack)="saveAndGoToStep(quoteSteps.chargingStationDetails, true)"
  ></evc-quote-technical-details>

  <evc-quote-house-details
    *ngIf="(step$ | async) === quoteSteps.houseDetails"
    [activeStep]="activeSubStep"
    formControlName="houseDetails"
    (stepNavigation)="stepNavigation($event)"
    (formReady)="saveAndGoToStep(quoteSteps.personalDetails)"
    (goBack)="saveAndGoToStep(quoteSteps.technicalDetails, true)"
  ></evc-quote-house-details>

  <evc-quote-personal-details
    *ngIf="(step$ | async) === quoteSteps.personalDetails"
    [activeStep]="activeSubStep"
    (stepNavigation)="stepNavigation($event)"
    formControlName="personalDetails"
    (formReady)="saveAndGoToStep(quoteSteps.confirmation)"
    (goBack)="saveAndGoToStep(getPersonalDetailsBackStep(), true)"
  ></evc-quote-personal-details>

  <evc-quote-confirmation
    *ngIf="(step$ | async) === quoteSteps.confirmation"
    formControlName="newsletters"
    (goBack)="saveAndGoToStep(quoteSteps.personalDetails, true)"
    (formReady)="submit()"
  >
  </evc-quote-confirmation>

  <div *ngIf="isLoading" class="page-loader">
    <div class="page-loader__desciption">{{ 'modules.evcQuote.general.loadText' | translate }}</div>
    <div class="page-loader__loader"></div>
  </div>
</form>
